<template>
  <divcard titled>
    <div class="card-part pt-0">
      <div class="txt-head black--text mb-2">
        <span class="theme-color-one">ส่วนที่ 2 :</span> ข้อมูลโครงการ
      </div>

      <!-- Form 1 -->
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoValidate('one')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            1. ข้อมูลหัวหน้าโครงการและคณะ
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 1 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                ชื่อ - สกุล
              </div>
              <div>{{ partTwoForm.s2_p1_name }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                ตำเเหน่ง
              </div>
              <div>{{ partTwoForm.s2_p1_position }}</div>
            </div>
          </div>

          <!-- Form 1 #line2 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                หน่วยงาน
              </div>
              <div>{{ partTwoForm.s2_p1_dep }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                สังกัด
              </div>
              <div>{{ partTwoForm.s2_p1_org }}</div>
            </div>
          </div>

          <!-- Form 1 #line3 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                ที่อยู่
              </div>
              <div>{{ partTwoForm.s2_p1_addr }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                เบอร์โทรศัพท์
              </div>
              <div>{{ partTwoForm.s2_p1_phone }}</div>
            </div>
          </div>

          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                E-mail
              </div>
              <div>{{ partTwoForm.s2_p1_email }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                ความเชี่ยวชาญ
              </div>
              <div>{{ partTwoForm.s2_p1_expertise }}</div>
            </div>
          </div>

          <!-- Form 1 #line4 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                สัดส่วนการทำงาน
              </div>
              <div>{{ partTwoForm.s2_p1_resp }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                ชั่วโมงการทำงาน
              </div>
              <div>{{ partTwoForm.s2_p1_resp_hrs }}</div>
            </div>
          </div>

          <v-divider v-if="partTwoForm.project_head_team && partTwoForm.project_head_team.length > 0"></v-divider>

          <!-- Head Team -->
          <div v-for="(team, i) in partTwoForm.project_head_team" :key="i">
            <div class="d-flex align-center gap-24 mb-3">

              <div class="font-type-bold black--text">
                1.{{ i + 1 }} ข้อมูลคณะ
              </div>
            </div>

            <div class="indent-info d-flex flex-column gap-8">
              <!-- Form 1 #line1 -->
              <div class="d-flex gap-16">
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    ชื่อ - สกุล
                  </div>
                  <div>{{ team.s2_p1_name }}</div>
                </div>
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    ตำเเหน่ง
                  </div>
                  <div>{{ team.s2_p1_position }}</div>
                </div>
              </div>

              <!-- Form 1 #line2 -->
              <div class="d-flex gap-16">
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    หน่วยงาน
                  </div>
                  <div>{{ team.s2_p1_dep }}</div>
                </div>
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    สังกัด
                  </div>
                  <div>{{ team.s2_p1_org }}</div>
                </div>
              </div>

              <!-- Form 1 #line3 -->
              <div class="d-flex gap-16">
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    ที่อยู่
                  </div>
                  <div>{{ team.s2_p1_addr }}</div>
                </div>
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    เบอร์โทรศัพท์
                  </div>
                  <div>{{ team.s2_p1_phone }}</div>
                </div>
              </div>

              <div class="d-flex gap-16">
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    E-mail
                  </div>
                  <div>{{ team.s2_p1_email }}</div>
                </div>
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    ความเชี่ยวชาญ
                  </div>
                  <div>{{ team.s2_p1_expertise }}</div>
                </div>
              </div>

              <!-- Form 1 #line4 -->
              <div class="d-flex gap-16">
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    สัดส่วนการทำงาน
                  </div>
                  <div>{{ team.s2_p1_resp }}</div>
                </div>
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    ชั่วโมงการทำงาน
                  </div>
                  <div>{{ team.s2_p1_resp_hrs }}</div>
                </div>
              </div>
          </div>

        </div>

      </div>

    </div>
    </div>

    <!-- Form 2 -->
    <div class="card-part">
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoValidate('two')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            2. ผู้รับผิดชอบโครงการ (Project Manager) (ภาคเอกชน)
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 1 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                ชื่อ - สกุล
              </div>
              <div>{{ partTwoForm.s2_p2_name }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                ตำเเหน่ง
              </div>
              <div>{{ partTwoForm.s2_p2_position }}</div>
            </div>
          </div>

          <!-- Form 1 #line2 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                หน่วยงาน
              </div>
              <div>{{ partTwoForm.s2_p2_dep }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                สังกัด
              </div>
              <div>{{ partTwoForm.s2_p2_org }}</div>
            </div>
          </div>

          <!-- Form 1 #line3 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                ที่อยู่
              </div>
              <div>{{ partTwoForm.s2_p2_addr }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                เบอร์โทรศัพท์
              </div>
              <div>{{ partTwoForm.s2_p2_phone }}</div>
            </div>
          </div>

          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                E-mail
              </div>
              <div>{{ partTwoForm.s2_p2_email }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                ความเชี่ยวชาญ
              </div>
              <div>{{ partTwoForm.s2_p2_expertise }}</div>
            </div>
          </div>

          <!-- Form 1 #line4 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                สัดส่วนการทำงาน
              </div>
              <div>{{ partTwoForm.s2_p2_resp }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                ชั่วโมงการทำงาน
              </div>
              <div>{{ partTwoForm.s2_p2_resp_hrs }}</div>
            </div>
          </div>

          <v-divider v-if="partTwoForm.project_manager_team && partTwoForm.project_manager_team.length > 0 "></v-divider>

          <!-- Head Team -->
          <div v-for="(team, i) in partTwoForm.project_manager_team" :key="i">
            <div class="d-flex align-center gap-24 mb-3">

              <div class="font-type-bold black--text">
                2.{{ i + 1 }} ชื่อ - สกุล ผู้รับผิดชอบโครงการ
              </div>
            </div>

            <div class="indent-info d-flex flex-column gap-8">
              <!-- Form 1 #line1 -->
              <div class="d-flex gap-16">
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    ชื่อ - สกุล
                  </div>
                  <div>{{ team.s2_p1_name }}</div>
                </div>
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    ตำเเหน่ง
                  </div>
                  <div>{{ team.s2_p1_position }}</div>
                </div>
              </div>

              <!-- Form 1 #line2 -->
              <div class="d-flex gap-16">
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    หน่วยงาน
                  </div>
                  <div>{{ team.s2_p1_dep }}</div>
                </div>
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    สังกัด
                  </div>
                  <div>{{ team.s2_p1_org }}</div>
                </div>
              </div>

              <!-- Form 1 #line3 -->
              <div class="d-flex gap-16">
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    ที่อยู่
                  </div>
                  <div>{{ team.s2_p1_addr }}</div>
                </div>
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    เบอร์โทรศัพท์
                  </div>
                  <div>{{ team.s2_p1_phone }}</div>
                </div>
              </div>

              <div class="d-flex gap-16">
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    E-mail
                  </div>
                  <div>{{ team.s2_p1_email }}</div>
                </div>
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    ความเชี่ยวชาญ
                  </div>
                  <div>{{ team.s2_p1_expertise }}</div>
                </div>
              </div>

              <!-- Form 1 #line4 -->
              <div class="d-flex gap-16">
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    สัดส่วนการทำงาน
                  </div>
                  <div>{{ team.s2_p1_resp }}</div>
                </div>
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    ชั่วโมงการทำงาน
                  </div>
                  <div>{{ team.s2_p1_resp_hrs }}</div>
                </div>
              </div>
            </div>

          </div>

        </div>

      </div>

    <!-- Form 3 -->
    <div class="card-part">
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoValidate('three')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            3. ผู้รับประสานงาน
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 1 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                ชื่อ - สกุล
              </div>
              <div>{{ partTwoForm.s2_pc_name }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                ตำเเหน่ง
              </div>
              <div>{{ partTwoForm.s2_pc_position }}</div>
            </div>
          </div>

          <!-- Form 1 #line2 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                เบอร์โทรศัพท์
              </div>
              <div>{{ partTwoForm.s2_pc_phone }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                E-mail
              </div>
              <div>{{ partTwoForm.s2_pc_email }}</div>
            </div>
          </div>

          <!-- Form 1 #line3 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                หน่วยงาน
              </div>
              <div>{{ partTwoForm.s2_pc_dep }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                ที่อยู่
              </div>
              <div>{{ partTwoForm.s2_pc_addr }}</div>
            </div>
          </div>

          <v-divider v-if="partTwoForm.project_coordinate_team && partTwoForm.project_coordinate_team.length > 0"></v-divider>

          <!-- Coordinate Team -->
          <div v-for="(team, i) in partTwoForm.project_coordinate_team" :key="i">
            <div class="d-flex align-center gap-24 mb-3">

              <div class="font-type-bold black--text">
                3.{{ i + 1 }} ชื่อ - สกุล ผู้รับประสานงาน
              </div>
            </div>

            <div class="indent-info d-flex flex-column gap-8">
              <!-- Form 1 #line1 -->
              <div class="d-flex gap-16">
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    ชื่อ - สกุล
                  </div>
                  <div>{{ team.s2_p1_name }}</div>
                </div>
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    ตำเเหน่ง
                  </div>
                  <div>{{ team.s2_p1_position }}</div>
                </div>
              </div>

              <div class="d-flex gap-16">
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    เบอร์โทรศัพท์
                  </div>
                  <div>{{ team.s2_p1_phone }}</div>
                </div>
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    E-mail
                  </div>
                  <div>{{ team.s2_p1_email }}</div>
                </div>
              </div>

              <!-- Form 1 #line2 -->
              <div class="d-flex gap-16">
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    หน่วยงาน
                  </div>
                  <div>{{ team.s2_p1_dep }}</div>
                </div>
                <div class="flex xs6 d-flex gap-16">
                  <div class="mb-1 black--text topic-field">
                    ที่อยู่
                  </div>
                  <div>{{ team.s2_p1_addr }}</div>
                </div>
              </div>

            </div>

          </div>

        </div>

      </div>

    <!-- Form 4 -->
    <div class="card-part">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoValidate('four')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            4. ข้อมูลภาคเอกชนที่เข้าร่วมโครงการ
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 2 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                ชื่อ - สกุล นิติบุคคล/กิจการ
              </div>
              <div>{{ partTwoForm.s2_p3_prv_org_name }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                ที่อยู่
              </div>
              <div>{{ partTwoForm.s2_p3_prv_org_address }}</div>
            </div>
          </div>

          <!-- Form 2 #line2 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                เบอร์โทรศัพท์
              </div>
              <div>{{ partTwoForm.s2_p3_prv_org_phone }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                E-mail
              </div>
              <div>{{ partTwoForm.s2_p3_prv_org_email }}</div>
            </div>
          </div>

          <!-- Form 2 #line3 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                รูปแบบของธุรกิจ/ลักษณะกิจการ (แบบย่อ)
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_p3_prv_org_type?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                รูปแบบผลิตภัณฑ์ (ผลิตภัณฑ์ใหม่/กระบวนการผลิตใหม่ มีความโดดเด่นและแตกต่างจากที่มีอยู่ในตลาด)
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_p3_prv_org_prod_design?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ความพร้อมของเอกชนในการร่วมวิจัยและพัฒนา
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_p3_prv_org_ready?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ศักยภาพของภาคเอกชนในการนำเทคโนโลยีไปต่อยอดทางธุรกิจ
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_p3_prv_org_potent?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>

          <!-- Form 2 #line4 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                แนวโน้มที่เอกชนจะนำงานวิจัยใช้ในการพัฒนาศักยภาพทางธุรกิจหรือเข้าร่วม Platform อื่นๆ ของอุทยานวิทยาศาสตร์เพื่อทำวิจัยในอนาคต
              </div>
              <div class="pl-10" v-html="partTwoForm.s2_p3_prv_org_trend?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>

          <!-- Form 2 #line5 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-3 black--text">
                สัดส่วนการลงทุนของเอกชนในการร่วมโครงการ
                <span class="theme-color-seven txt-normal">(ข้อมูลมาจากส่วนที่3)</span>
              </div>

              <div>
                <ul>
                  <li>
                    <div class="d-flex justify-space-between" style="gap: 16px">
                      <div class="black--text pt-2">ภาคเอกชนสนับสนุนจำนวน</div>
                      <div class="d-flex justify-end" style="gap: 16px">
                        <div class="pt-2">{{ formatNumber(private_sum,2) }}</div>
                        <div class="black--text pt-2">บาท</div>
                        <div class="black--text pt-2" style="min-width: 80px; max-width: 80px">โดยแบ่งเป็น</div>
                        <div style="min-width: 200px; max-width: 200px"></div>
                      </div>
                    </div>

                    <ul style="list-style: none">
                      <li>
                        <div class="d-flex justify-space-between" style="gap: 16px">
                          <div class="pt-2">ส่วนที่เป็นตัวเงิน(In-cash)จำนวน</div>
                          <div class="pt-2 d-flex justify-end" style="gap: 16px">
                            <div class="pt-2">{{ formatNumber(incash_sum,2) }}</div>
                            <div class="pt-2">บาท</div>
                            <div class="pt-2" style="min-width: 80px; max-width: 80px">คิดเป็นร้อยละ</div>
                            <div class="pt-2">{{ incash_percent }}</div>
                            <div style="min-width: 200px; max-width: 200px"></div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="d-flex justify-space-between" style="gap: 16px">
                          <div class="pt-2">ส่วนที่เป็นสิ่งของสนับสนุน(In-Kind)จำนวน</div>
                          <div class="pt-2 d-flex justify-end" style="gap: 16px">
                            <div class="pt-2">{{ formatNumber(inkind_sum,2) }}</div>
                            <div class="pt-2">บาท</div>
                            <div class="pt-2" style="min-width: 80px; max-width: 80px">คิดเป็นร้อยละ</div>
                            <div class="pt-2">{{ inkind_percent }}</div>
                            <div style="min-width: 200px; max-width: 200px"></div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <div class="d-flex justify-space-between" style="gap: 16px">
                      <div class="black--text pt-2">อุทยานวิทยาศาสตร์ภูมิภาค สนับสนุนจำนวน</div>
                      <div class="d-flex justify-end" style="gap: 16px">
                        <div class="pt-2">{{ formatNumber(scipark_sum,2) }}</div>
                        <div class="black--text pt-2">บาท</div>
                        <div class="black--text pt-2" style="min-width: 80px; max-width: 80px">คิดเป็นร้อยละ</div>
                        <div class="pt-2">{{ scipark_percent }}</div>
                        <div style="min-width: 200px; max-width: 200px"></div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </div>

      </div>

    </div>

    <!-- Form 5 -->
    <div class="card-part">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_p4_prv_org_involved ? true : false"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            5. กิจการของภาคเอกชนที่เข้าร่วมโครงการมีความเกี่ยวข้องในกลุ่มอุตสาหกรรม
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 4 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="Array.isArray(partTwoForm.s2_p4_prv_org_involved) ? partTwoForm.s2_p4_prv_org_involved.join(', <br>') : ''"></div>
            </div>
          </div>
          <!-- Form 4 #line2 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div><b>ระบุเพิ่มเติม:</b> {{ partTwoForm.s2_p4_prv_org_other ? partTwoForm.s2_p4_prv_org_other : '-' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 6 -->
    <div class="card-part">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_p7_source ? true : false"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            6. ที่มาและความสำคัญ
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 7 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_p7_source?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 7 -->
    <div class="card-part">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_p8_objective ? true : false"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            7. วัตถุประสงค์
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 7 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_p8_objective?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 8 -->
    <div v-if="!isFinal" class="card-part">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoValidate('five')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            8. ศักยภาพและความพร้อมในการดำเนินโครงการ
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 5 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ความเข้มข้นของการใช้ ผลงานวิจัย ต้นแบบ ที่มีผลพิสูจน์ในระดับห้องปฏิบัติการ ระดับของเทคโนโลยี(ที่สามารถใช้อ้างอิงได้ เช่น ระดับ TRL)
                และความรู้ ความเชี่ยวชาญของบุคลากรที่มีอยู่ของมหาวิทยาลัยในการสนับสนุนการวิจัยและพัฒนาร่วมกับภาคเอกชน
                (อธิบายในลักษณะของเทคโนโลยีที่ใช้ เป็นรูปแบบ เทคโนโลยีที่เหมาะสม (Appropriate Technology)
                ซึ่งเป็นเทคโนโลยีที่มีความพร้อมในการดำเนินงานในลักษณะที่มีความพร้อมสู่การนำไปใช้จริง
              </div>
              <div v-html="partTwoForm.s2_p5_intensity?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 5 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ความพร้อมของห้องปฏิบัติการ เครื่องมืออุปกรณ์ทางวิทยาศาสตร์และสิ่งอำนวยความสะดวก
              </div>
              <div v-html="partTwoForm.s2_p5_lab_readiness?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>

          <!-- Form 5 #line3 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ประสบการณ์การทำงานร่วมกับภาคอุตสาหกรรมของทีมวิจัยของโครงการ
              </div>
              <div v-html="partTwoForm.s2_p5_collab_exp?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>

          <!-- Form 5 #line4 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                เทคโนโลยีที่เกี่ยวข้องในโครงการมีศักยภาพในการนำมาพัฒนาสู่เชิงพาณิชย์ (Proven technology with high for commercialization)
                เช่น มีผลการทดลองในระดับห้องปฏิบัติการ หรือมีผลิตภัณฑ์ต้นแบบแล้ว เป็นต้น
              </div>
              <div v-html="partTwoForm.s2_p5_tech_involved?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>

          <!-- Form 5 #line5 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ผลลัพธ์ของโครงการ เช่น เกิดผลิตภัณฑ์ใหม่ที่มีมูลค่าเพิ่มสูง หรือกระบวนการผลิตใหม่ที่มีประสิทธิภาพสูง ซึ่งไม่เคยมีมาก่อนในระดับประเทศหรือภูมิภาค
              </div>
              <div v-html="partTwoForm.s2_p5_project_result?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>

          <!-- Form 5 #line5 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                เอกสารอ้างอิง หรือ ข้อมูล ที่แสดงถึงความสำเร็จของงานวิจัยที่ได้ดำเนินก่อนหน้านี้
              </div>
              <div v-html="partTwoForm.s2_p5_reference?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div v-if="isFinal" class="card-part">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_p6_project_scope ? true : false"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            8. ขั้นตอนและขอบเขตการดำเนินโครงการ
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 6 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_p6_project_scope?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 9 -->
    <div v-if="!isFinal" class="card-part">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_p6_project_scope ? true : false"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            9. ขั้นตอนและขอบเขตการดำเนินโครงการ
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 6 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_p6_project_scope?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isFinal" class="card-part">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.s2_result ? true : false"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            9. ผลการดำเนินงาน
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 6 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_result?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form 10 -->
<!--    <div v-if="!isFinal" class="card-part">-->
<!--      <div>-->
<!--        <div class="d-flex align-center gap-24 mb-3">-->
<!--          <ValidatorIcon-->
<!--              v-if="!$route.query.preview && dataReady"-->
<!--              :is-correct="partTwoForm?.s2_p9_location ? true : false"-->
<!--          ></ValidatorIcon>-->

<!--          <div class="font-type-bold black&#45;&#45;text">-->
<!--            9. สถานที่ดำเนินงานวิจัยและรายละเอียดห้องปฏิบัติการ-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="indent-info d-flex flex-column gap-8">-->
<!--          &lt;!&ndash; Form 7 #line1 &ndash;&gt;-->
<!--          <div class="d-flex gap-16">-->
<!--            <div class="flex xs6 d-flex gap-16">-->
<!--              <div v-html="partTwoForm.s2_p9_location?.replace(/\n/g, '<br>')"></div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

  </divcard>
</template>

<script>
import TextField from "../../../../components/input/TextField"
import SwitchInset from ".././../../../components/input/SwitchInset"
import AutoBox from "../../../../components/input/AutoBox"
import {eventBus, formatNumber, validateEmail} from "@/plugins/global-funcs"
import { mapState } from "vuex"
import OOILineField from '../../../../components/OOILineField'
import ValidatorIcon from "../../../../components/ValidatorIcon"
import {format} from "date-fns";
import {th} from "date-fns/locale";

export default {
  name: "CFormSummary_CR",
  components: {
    TextField,
    SwitchInset,
    AutoBox,
    OOILineField,
    ValidatorIcon
  },
  props: {
    data: {
      default: () => ({})
    },
    masterData: {
      default: () => ({})
    },
    budgetList: {
      default: () => ([])
    },
    isSameId: {
      default: false
    }
  },
  data () {
    return {
      formatNumber,
      private_sum: null,
      inkind_sum: null,
      incash_sum: null,
      scipark_sum: null,
      inkind_percent: null,
      incash_percent: null,
      scipark_percent: null,
      partOneForm: {},
      partTwoForm: {},
      shortMonths: [],
      partThreeForm: {},
      partThreeAllPlans: [],
      partThreeBudgetPlans: [],
      partThreeBudgetList: [],
      partThreeAllProgressPlan: [],
      kpi: {},
      partFiveAttachment: [],
      ableToSubmit: true,
      dataReady: false
    }
  },
  computed: {
    ...mapState({
      // GeneralForm: state => state.CForm.GeneralForm,
      // ProjectForm: state => state.CForm.ProjectForm,
      // PlanForm: state => state.CForm.PlanForm,
      // OOIForm: state => state.CForm.OOIForm,
      // AttachmentForm: state => state.CForm.AttachmentForm,
      SummaryData: state => state.CForm.SummaryData
    }),
    isFinal () {
      return this.$route.query.doc_type && this.$route.query.doc_type === 'progress'
    }
  },
  async created () {
    eventBus.$emit('cFormSummary')
    await new Promise((res, rej) => setTimeout(res, 100))

    this.partTwoForm = this.data;

    this.calculateBudgetProportion();
    this.dataReady = true
  },
  methods: {
    allowFormAbleSubmit(isCorrect) {
      if (!isCorrect && this.dataReady) {
        this.ableToSubmit = false;
      }
      eventBus.$emit("CFormPlanAbleToSubmit", this.ableToSubmit);
    },
    calculateBudgetProportion(){
      let budgetList = this.budgetList

      if(budgetList !== undefined && budgetList.length > 0){
        let all_sum = budgetList.map(x => x.budget_sum).reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        this.inkind_sum = budgetList.map(x => x.budget_in_kind).reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        this.incash_sum = budgetList.map(x => x.budget_in_cash).reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        this.private_sum = this.inkind_sum + this.incash_sum;
        this.scipark_sum = budgetList.map(x => x.budget_sci_park).reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        this.inkind_percent = (this.inkind_sum * 100 / all_sum).toFixed(2)
        this.incash_percent = (this.incash_sum * 100 / all_sum).toFixed(2)
        this.scipark_percent = (this.scipark_sum * 100 / all_sum).toFixed(2)

      }
    },
    partTwoValidate (section) {
      let isCorrect = true
      switch (section) {
        case 'one':
          if (
              !this.partTwoForm.s2_p1_name ||
              !this.partTwoForm.s2_p1_position ||
              !this.partTwoForm.s2_p1_dep ||
              !this.partTwoForm.s2_p1_org ||
              !this.partTwoForm.s2_p1_addr ||
              !this.partTwoForm.s2_p1_expertise ||
              !this.partTwoForm.s2_p1_resp
          ) { isCorrect = false }

          if (
              !this.partTwoForm.s2_p1_phone
          ) { isCorrect = false }

          if (
              !validateEmail(this.partTwoForm.s2_p1_email)
          ) { isCorrect = false }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case 'two':
          if (
              !this.partTwoForm.s2_p2_name ||
              !this.partTwoForm.s2_p2_position ||
              !this.partTwoForm.s2_p2_dep ||
              !this.partTwoForm.s2_p2_org ||
              !this.partTwoForm.s2_p2_addr ||
              !this.partTwoForm.s2_p2_phone ||
              !this.partTwoForm.s2_p2_email ||
              !this.partTwoForm.s2_p2_expertise ||
              !this.partTwoForm.s2_p2_resp ||
              !this.partTwoForm.s2_p2_resp_hrs
          ) { isCorrect = false }

          if (
              !this.partTwoForm.s2_p2_phone
          ) { isCorrect = false }

          if (
              !validateEmail(this.partTwoForm.s2_p2_email)
          ) { isCorrect = false }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case 'three':

          if (
              !this.partTwoForm.s2_pc_name ||
              !this.partTwoForm.s2_pc_position ||
              !this.partTwoForm.s2_pc_phone ||
              !this.partTwoForm.s2_pc_email ||
              !this.partTwoForm.s2_pc_dep ||
              !this.partTwoForm.s2_pc_addr
          ) { isCorrect = false }

          if (
              !this.partTwoForm.s2_pc_phone
          ) { isCorrect = false }

          if (
              !validateEmail(this.partTwoForm.s2_pc_email)
          ) { isCorrect = false }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case 'four':

            if (
                !this.partTwoForm.s2_p3_prv_org_name ||
                !this.partTwoForm.s2_p3_prv_org_address ||
                !this.partTwoForm.s2_p3_prv_org_phone ||
                !this.partTwoForm.s2_p3_prv_org_email ||
                !this.partTwoForm.s2_p3_prv_org_type ||
                !this.partTwoForm.s2_p3_prv_org_prod_design ||
                !this.partTwoForm.s2_p3_prv_org_ready ||
                !this.partTwoForm.s2_p3_prv_org_potent ||
                !this.partTwoForm.s2_p3_prv_org_trend ||
                !this.private_sum ||
                !this.incash_sum ||
                !this.inkind_sum
            ) { isCorrect = false }

          if (
              !this.partTwoForm.s2_p3_prv_org_phone
          ) { isCorrect = false }

            if (
                !validateEmail(this.partTwoForm.s2_p3_prv_org_email)
            ) { isCorrect = false }

            this.allowFormAbleSubmit(isCorrect);
            return isCorrect;

        case 'five':

          if (
              !this.partTwoForm.s2_p5_intensity ||
              !this.partTwoForm.s2_p5_lab_readiness ||
              !this.partTwoForm.s2_p5_collab_exp ||
              !this.partTwoForm.s2_p5_tech_involved ||
              !this.partTwoForm.s2_p5_project_result ||
              !this.partTwoForm.s2_p5_reference
          ) { isCorrect = false }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;
      }
    },
  }
}
</script>

<style scoped lang="scss">
.budget-item,
.summary-plan {
  background: #FFFFFF;
  box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding: 12px;
}

.summary-plan {
  min-height: 78px;
}

.remark-box {
  color: var(--theme-color-seven);
  background: #FAFAFA;
  border-radius: 20px;
  padding: 12px;
  font-size: 10px;
}

.plan-card {
  background: #FFFFFF;
  box-shadow: 1px 1px 18px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  border: 1px solid transparent;
  padding: 12px;
  min-width: max-content;
  &.plan-active {
    border: 1px solid var(--theme-color-seven);
  }
}


.plan-field-form {
  /* User input values. */
  --grid-layout-gap: 16px;
  --grid-column-count: 6;
  --grid-item--min-width: 130px;

  /* Calculated values. */
  --gap-count: calc(var(--grid-column-count) - 1);
  --total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));
  --grid-item--max-width: calc((100% - var(--total-gap-width)) / var(--grid-column-count));

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr));
  grid-gap: var(--grid-layout-gap);
}

.plan-slot > div {
  transition: background-color 400ms;
  background-color: #fff;
  height: 20px;
}
.plan-slot .progress-plan-mark {
  background-color: var(--theme-color-one);
  min-width: 45px;
  display: flex;
  align-items: center;
  padding-top: 1px;
  .v-divider {
    border-color: #fff;
  }
}

.progress-plan-mark.start-point {
  border-radius: 30px 0 0 30px;
  padding-left: 4px;
}

.progress-plan-mark.end-point {
  border-radius: 0 30px 30px 0;
  padding-right: 6px;
}

.arrow-right {
  display: none;
}
.end-point .arrow-right {
  display: unset;
  font-family: 'Tahoma', sans-serif;
  margin-left: -8px;
  margin-top: -3px;
  user-select: none;
}
.topic-field {
  min-width: 160px;
  max-width: 160px;
}
.indent-info {
  padding-left: 85px;
}
</style>